export interface Review {
    name: string;
    rating: number;
    addedAt: string;
    details: string;
    review: string;
    courseInfo?: string; // Optional field for course information
}

// Sample reviews data
export const reviews: Review[] = [
    {
        name: "Antoni",
        rating: 5,
        addedAt: "2025-05-01",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Do tej pory nie zaobserwowałem żadnych błędów i dowiedziałem się co mam robić aby poprawić swoje wyniki</p>"
    },
    {
        name: "Tomek",
        rating: 5,
        addedAt: "2025-04-27",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs jest bardzo fajny pomaga mi w nauce.</p>"
    }, {
        name: "Franciszek",
        rating: 5,
        addedAt: "2025-04-23",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Jest fajnie tylko muszę długo czekać żeby mi się odblokował tydzień. Niczego mi nie brakuje.</p>"
    },
    {
        name: "Patrycja",
        rating: 5,
        addedAt: "2025-04-21",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Dzięki kursowi lepiej mam zaplanowaną naukę. Kurs mi się podoba.</p>"
    },
    {
        name: "Tymoteusz",
        rating: 5,
        addedAt: "2025-04-19",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Wiem, jak się przygotować do testów, wiem, jak czytać ze zrozumieniem.</p>"
    },
    {
        name: "Tymon",
        rating: 5,
        addedAt: "2025-04-15",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Bardzo dobrze mi sie z panem wspolpracuje na spotkaniach grupowych. Zawsze moge zadac pytania i uzyskac pomoc. Czuje sie tam bardzo swobodnie. Kurs pomaga mi w nauce i systematycznosci. Po 3 tygodniach widze realna poprawe w mojej wydajnosci. Plan dominacji swietnie sie sprawdza i korzystam z niego codziennie. </p>"
    },
    {
        name: "Mateusz",
        rating: 5,
        addedAt: "2025-04-13",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Naprawdę fajny polecam każdemu. Wszystko mi pasuje i nie mam żadnych uwag.</p>"
    },
    {
        name: "Julia",
        rating: 5,
        addedAt: "2025-04-11",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Jestem bardzo zadowolona. Długo zajęło mi rozpoczęcie, ale jak już rodzice przestali mi ciągle o tym gadać, to poszlo jakos łatwiej :) Kurs jest bardzo wartosciowy i pomaga mi na codzien.</p>"
    },
    {
        name: "Sara",
        rating: 5,
        addedAt: "2025-04-06",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Bardzo mi się podoba sposób w który to wszystko jest tłumaczone. Kurs jest bardzo przydatny</p>"
    },
    {
        name: "Pola",
        rating: 4,
        addedAt: "2025-03-30",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest ciekawy i dobrze rozplanowany, chociaż lekcje mogłyby być troszkę krótsze.</p>"
    },
    {
        name: "Jakub",
        rating: 5,
        addedAt: "2025-03-30",
        details: "",
        courseInfo: "Uczestnik Kursu Efektywnego Działania",
        review: "<p>Kurs jest naprawdę przydatny. Dowiedziałem się kilku rzeczy, które mi się przydały. Niczego mi nie brakowało.</p>"
    },
    {
        name: "Elżbieta",
        rating: 5,
        addedAt: "2025-03-25",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs okazał się pomocny w motywacji i podejmowaniu nowych wyzwań. Niczego mi nie brakowało. Gdybym miała magiczną różdżkę to chciałabym tą całą wiedzę przyswoić od razu. Niestety jest to proces długotrwały. </p>"
    },
    {
        name: "Magda",
        rating: 5,
        addedAt: "2025-03-22",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest bardzo pomagający. Na tą chwilę wdrażam w życie zadania, które są na tym kursie. Zrobiłabym tylko trochę krótsze lekcje, a tak to wszystko jest okej.</p>"
    },
    {
        name: "Ilona",
        rating: 5,
        addedAt: "2025-03-20",
        details: "",
        courseInfo: "Uczestniczka Kursu Efektywnego Działania",
        review: "<p>Kurs jest opracowany zrozumiale, ale ja nie wykonuję systematycznie ćwiceń. Wszystko było w porządku, podoba mi się metoda małych kroków. Na razie niczego bym nie zmieniała.</p>"
    },
    {
        name: "Grzesiek",
        rating: 5,
        addedAt: "2025-03-11",
        details: "Uczeń III klasy Technikum",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Bardzo fajnie. Nauczyłem się jak lepiej zapamiętywać, bo przed zajęciami kułem na pamięć, a teraz lepiej mi to wychodzi. Na pewno nauczyłem się tego, jak lepiej się uczyć - np. mieć porządek i wyrzucić telefon z pokoju. Pomógł mi również schemat powtórek - robię to teraz z głową i nie jest to całkowicie losowe. Dziękuję za pomoc. </p>"
    },
    {
        name: "Zosia",
        rating: 5,
        addedAt: "2025-03-05",
        details: "Uczennica I klasy Technikum",
        courseInfo: "Uczestniczka programu MISTRZOWSKIE Wsparcie",
        review: "<p>Najbardziej podobało mi się stopniowe podejście. Planowanie bardzo mi się przydało. Miałam problem z organizacją - nie umiałam się zaangażować i przerobić tego co powinnam. Teraz jest o wiele łatwiej. Nauka też idzie mi znacznie lepiej i pamiętam o obowiazkach domowych. </p>"
    },
    {
        name: "Wiktoria",
        rating: 5,
        addedAt: "2025-03-01",
        details: "Uczennica III klasy Liceum",
        courseInfo: "Uczestniczka programu MISTRZOWSKIE Wsparcie",
        review: "<p>Ogólnie wszystko jasno wyjaśnione, fajnie, że była tablica udostępniona. Bardzo podobał mi się styl prowadzenia zajęć i przerabiany materiał. W sumie nie uważam, żeby miała na co narzekać, ewentualnie fakt, że częstotliwość wprowadzenia nowych rzeczy była dość duża. </p>"
    },
    {
        name: "Magdalena",
        rating: 5,
        addedAt: "2025-02-10",
        details: "Mama Huberta, maturzysty",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Czuję, że Hubertowi współpraca z Panem pokazała i uświadomiła parę ważnych rzeczy. Bardzo dziękuję, za to, co do tej pory dał Pan Hubertowi, myślę, że na pewno będzie to dla niego wspierająca wiedza.</p>"
    },
    {
        name: "Dawid",
        rating: 5,
        addedAt: "2025-02-09",
        details: "Uczeń VII klasy SP",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Ogolnie zajecia sie podobaly, duzo sie nauczylem. Najbardziej przydalo mi się robienie powtorek po zajeciach oraz techniki efektywnej nauki. Cykl Kobla tez byl bardzo ciekawym narzedziem. Postepy sa dobre i czuje ze dzialanie idzie mi znacznie lepiej.</p>"
    },
    {
        name: "Igor",
        rating: 5,
        addedAt: "2025-02-01",
        details: "Uczeń I klasy Liceum",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Hej, program był naprawdę super. Dzięki Twojemu podejściu czułem się swobodnie – fajny kontakt i luźna atmosfera bardzo mi pomogły. Najbardziej doceniam konkretne wskazówki dotyczące organizacji i efektywnej nauki. Szczególnie cykl Kolba, który co jakiś czas wprowadzaliśmy na zajęciach, pozwolił mi lepiej zrozumieć jak skutecznie uczyć się na własnych doświadczeniach. Czuję też wyraźną poprawę koncentracji, co przekłada się na moje wyniki w szkole i codzienne zadania.</p>"
    },
    {
        name: "Julia",
        rating: 5,
        addedAt: "2025-01-17",
        details: "Uczennica II klasy Liceum",
        courseInfo: "Uczestniczka programu MISTRZOWSKIE Wsparcie",
        review: "<p>hej mikołaj ogólnie bardzo podobają mi się te zajęcia, nauczyłam się o wiele więcej niż zakładałam; najbardziej przydatne są dla mnie rady dotyczące nauki i realizacji celów. najbardziej w zajęciach mi się podoba, że rzeczywiście słuchasz z czym mogę mieć problem i starasz się dostosować następną lekcje, żeby mi z tym pomóc. myślę, że też fajne jest to, że wszystko mi rozrysowujesz, bo u mnie rzeczywiście zapamiętanie czegoś z samego słuchu no jest dość ciężkie. na plus jest też fakt, że nie prowadzisz tych zajęć tak bardzo szkolnie (??), że po prostu mogę normalnie z tobą rozmawiać o wszystkim bez jakiegoś nacisku na to, że tqk naprawdę jesteś moim nauczycielem(?). </p>"
    },
    {
        name: "Dominik",
        rating: 5,
        addedAt: "2025-01-15",
        details: "Student ekonomii",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Hej, na pewno Gallup jest na plus, bo raz że podnosi samoświadomość i samoocenę, to jeszcze uruchamia fajne rozkminy na swój temat. <br/><br/>" +
            "A bardziej osobiście podoba mi sie Twoje realne podejście do zajęć. To znaczy, że nie sprzedajesz gruszek na wierzbie i nie klepiesz po ramionku, tylko efektywnie motywujesz i pokazujesz właśnie te techniki i narzedzia, dzięki którym można na prawdę wiele zdziałać w życiu.<br/><br/>" +
            "Z rzeczy które mi sie przydały i które wiem, że działają to chyba nie muszę mówić, bo to jest jakieś 80% materiału, który razem przerobiliśmy i ciężko trochę powiedzieć co konkretnie. </p>"
    },
    {
        name: "Ignacy",
        rating: 5,
        addedAt: "2024-12-18",
        details: "Uczeń II klasy Technikum",
        courseInfo: "Uczestnik programu MISTRZOWSKIE Wsparcie",
        review: "<p>Bardzo podobały mi się nasze zajęcia. Czułem się swobodnie i mogłem o wszystkim powiedzieć. Nie miałem żadnej spiny jak coś nie wychodziło. Z samego materiału najbardziej przydały mi się techniki efektywnej nauki, a przede wszystkim nauka poprzez dociekanie. Jest to bardzo zabawne i jednocześnie angażujące.</p>"
    },
];
